import {JsonProperty} from '@hyperloris/tyson';
import {Account} from './account';
import {DateTime} from 'luxon';
import {AccountDefinition} from "../customer/account-definition";
import {Trade} from "./trade";
import {Order} from "./order";

export class Clearing {

  @JsonProperty()
  id: string | undefined;

  @JsonProperty()
  exchangeOrderId: string | undefined;

  @JsonProperty()
  orderId: string | undefined;

  @JsonProperty()
  tradeId: string | undefined;

  @JsonProperty()
  volume: number;

  @JsonProperty()
  state: Clearing.ClearingState = Clearing.ClearingState.WAITING;

  @JsonProperty()
  exchangeCode: string | undefined;

  @JsonProperty()
  clearingDate: Date = new Date();

  @JsonProperty()
  tradeReference: string | undefined;

  @JsonProperty()
  openClose: AccountDefinition.OpenClose = AccountDefinition.OpenClose.NO;

  @JsonProperty()
  account: Account;

  @JsonProperty()
  giveUp: boolean;

  @JsonProperty()
  giveUpBrokerCode: string | undefined;

  @JsonProperty()
  giveUpMessage: string | undefined;

  @JsonProperty()
  giveUpMessage2: string | undefined;

  @JsonProperty()
  giveUpMessage3: string | undefined;

  @JsonProperty()
  giveUpAccountType: string | undefined;

  @JsonProperty()
  giveUpCommission: string | undefined;

  @JsonProperty()
  reason: string | undefined;

  @JsonProperty()
  creationDate: DateTime = DateTime.now();

  @JsonProperty()
  modificationDate: DateTime = DateTime.now();

  @JsonProperty()
  sendingDate: DateTime = DateTime.fromMillis(1000);

  @JsonProperty()
  confirmationDate: DateTime = DateTime.fromMillis(1000);

  @JsonProperty()
  allocationId: string | undefined;

  @JsonProperty()
  avgGroupId: string | undefined;

  @JsonProperty()
  overrideAvgPrice: number;

  @JsonProperty()
  exported: boolean = false;


  @JsonProperty()
  brokerageFee: number;
  @JsonProperty()
  brokerageCurrency: string | undefined;

  @JsonProperty()
  overrideBrokerageFee: number;

  @JsonProperty()
  brokerageRateAmount: number;

  @JsonProperty()
  technicalFreeText1: string | undefined;
  @JsonProperty()
  technicalFreeText2: string | undefined;
  @JsonProperty()
  technicalFreeText3: string | undefined;
  @JsonProperty()
  technicalFreeText4: string | undefined;
  @JsonProperty()
  technicalFreeText5: string | undefined;

  @JsonProperty()
  trade: Trade;

  @JsonProperty()
  order: Order;

}

export module Clearing {
  export enum ClearingState {
    WAITING = 'WAITING',
    IN_PROGRESS = 'IN_PROGRESS',
    PENDING_ALLOCATION = 'PENDING_ALLOCATION',
    ALLOCATED = 'ALLOCATED',
    IN_PROGRESS_CANCELLATION = 'IN_PROGRESS_CANCELLATION',
    PENDING_CANCELLATION = 'PENDING_CANCELLATION',
    PENDING_GIVEUP = 'PENDING_GIVEUP',
    ACCEPTED_GIVEUP = 'ACCEPTED_GIVEUP',
    REJECTED_GIVEUP = 'REJECTED_GIVEUP',
    ERROR = 'ERROR',
    IN_PROGRESS_REJECT = 'IN_PROGRESS_REJECT',
    PENDING_TAKEUP = 'PENDING_TAKEUP',
    DISCARDED = 'DISCARDED',
    PENDING_MARK_AS_GIVEUP = 'PENDING_MARK_AS_GIVEUP',
    IN_PROGRESS_REVERSAL = 'IN_PROGRESS_REVERSAL',
    PENDING_REVERSAL = 'PENDING_REVERSAL',
    REVERSAL_REQUESTED = 'REVERSAL_REQUESTED',
    IN_PROGRESS_CANCELLATION_REVERSAL = 'IN_PROGRESS_CANCELLATION_REVERSAL',
    PENDING_CANCELLATION_REVERSAL = 'PENDING_CANCELLATION_REVERSAL',
    PENDING_REJECT = 'PENDING_REJECT'
  }
}
